module.exports = __webpack_public_path__ + "static/media/toast_success.1105bf83.svg";